export { default } from './Page2ColumnLayout';
